<style scoped>
.ercode {
  width: 70%;
}
@media screen and (max-width: 900px) {
  .ercode {
    width: 100%;
  }
}
#full-box {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: white;
}
#full-box-content {
  width: 100%;
  height: 100%;
}
</style>
<template>
  <div id="app">
    <div id="full-box">
      <div style="margin: 5px">
        <el-button type="primary" plain size="mini" id="full-exit"
          >返回</el-button
        >
      </div>
      <div id="full-box-content"></div>
    </div>
    <div class="main">
      <div class="container-full header">
        <div class="container header-normal">
          <router-link to="/">
            <div class="logo">
              <img src="/static/logo.png" />
            </div>
          </router-link>
          <el-menu
            :router="true"
            class="el-menu-demo menu"
            mode="horizontal"
            style="border-bottom: 0"
            :default-active="this.$route.path"
          >
            <el-menu-item index="/jibenmian">基本面分析</el-menu-item>
            <el-menu-item index="/chicang">主力持仓</el-menu-item>
            <el-menu-item index="/yanbao">研究报告</el-menu-item>
            <el-menu-item index="/xinxipilu">信息披露</el-menu-item>
            <el-menu-item index="/shoufa">首发申报</el-menu-item>
            <el-menu-item index="/datalab">数据实验室</el-menu-item>
            <el-menu-item>
              <div class="search">
                <!-- <el-input placeholder="请输入股票代码、名称、简拼" size="small" v-model="vm.searchKey" @input="searchKeys">
                  <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                </el-input> -->
                <el-autocomplete
                  size="small"
                  v-model="vm.searchKey"
                  :fetch-suggestions="searchKeys"
                  placeholder="请输入股票代码、名称、简拼"
                  @select="search"
                ></el-autocomplete>
                <div class="search-keys" style="z-index: 9999">
                  <div
                    class="search-keys-item"
                    v-for="item in vm.searchKeys"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </el-menu-item>
          </el-menu>
          <div class="login" v-if="!this.$store.state.user">
            <el-link :underline="false" @click="login">登录</el-link>
          </div>
          <div class="login" v-if="this.$store.state.user">
            <div>
              <el-menu
                class="el-menu-demo user"
                mode="horizontal"
                @select="handleSelect"
              >
                <el-submenu index="1">
                  <template slot="title">
                    <el-avatar
                      :src="this.$store.state.user.headimgurl"
                      size="medium"
                    ></el-avatar>
                    &nbsp;&nbsp; {{ this.$store.state.user.nickname }}
                  </template>
                  <el-menu-item index="user-favorite">收藏夹</el-menu-item>
                  <el-menu-item index="user-exit">退出</el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
          </div>
        </div>
        <div class="header-mini">
          <div class="header-mini-wrap">
            <div class="left">
              <router-link to="/">
                <div class="logo-mini">
                  <img src="/static/logo.png" />
                </div>
              </router-link>
            </div>
            <div class="center"></div>
            <div class="right">
              <i
                class="el-icon-search"
                style="font-size: 26px; margin-top: 2px"
                @click="showMiniSearch"
              ></i>
              &nbsp;&nbsp;
              <i
                class="el-icon-user-solid"
                style="font-size: 26px; margin-top: 2px"
                @click="showMiniUser"
              ></i>
              &nbsp;&nbsp;
              <i
                class="el-icon-menu"
                style="font-size: 26px; margin-top: 2px"
                @click="showMiniMenu"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div :class="[this.$route.path === '/' ? 'container-full' : 'container']">
        <router-view />
      </div>
    </div>
    <div class="container-full footer">
      <!-- <div class="footer-links">
        <el-link :underline="false">联系我们</el-link>
        <span>|</span>
        <el-link :underline="false">用户协议</el-link>
        <span>|</span>
        <el-link :underline="false">用户隐私权</el-link>
        <span>|</span>
        <el-link :underline="false">友情链接</el-link>
        <span>|</span>
        <el-link :underline="false">关于我们</el-link>
        <span>|</span>
        <el-link :underline="false">用户帮助</el-link>
        <span>|</span>
        <el-link :underline="false">名词百科</el-link>
        <span>|</span>
        <el-link :underline="false">产品标签</el-link>
        <span>|</span>
        <el-link :underline="false">更新记录</el-link>
      </div>
      <div class="container">
        <div class="footer-line"></div>
      </div> -->
      <div
        class="footer-copyright"
        style="padding-top: 40px; padding-bottom: 40px; margin-top: 20px"
      >
        <!-- <div>
          <a
            target="_blank"
            href="http://www.beian.miit.gov.cn/"
            style="color: #536287;"
            >粤ICP备19124991号</a
          >
          ©静水流深 版权所有
        </div>
        <div>
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049002000630"
            ><img
              style="height:14px;margin-bottom:-1px;"
              src="/static/icon/ba.png"
          /></a>
          粤公网安备 44049002000630号
        </div> -->
        <div class="container">
          <el-row>
            <el-col :span="20" :offset="2">
              <el-col :span="16">
                <div style="font-weight: 400; color: white; line-height: 22px">
                  郑重声明
                </div>
                <div style="font-size: 12px; line-height: 22px">
                  本站发布此信息的目的在于传播更多信息，与本站立场无关。本站不保证该信息（包括但不限于文字、视频、音频、数据及图表）全部或者部分内容的准确性、真实性、完整性、有效性、及时性、原创性等。相关信息并未经过本网站证实，不对您构成任何投资建议，据此操作，风险自担。
                </div>
                <div style="font-size: 12px; line-height: 32px">
                  <div style="float: left; margin-right: 16px">
                    <a
                      target="_blank"
                      href="https://beian.miit.gov.cn/"
                      style="color: #536287"
                      >粤ICP备2023046923号-1</a
                    >
                    ©版权所有
                  </div>
                  <div style="float: left">
                    <a
                      target="_blank"
                      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049002000630"
                      ><img
                        style="height: 14px; margin-bottom: -1px"
                        src="/static/icon/ba.png"
                    /></a>
                    粤公网安备 44049002000630号
                  </div>
                </div>
              </el-col>
              <el-col :span="4" style="text-align: center">
                <div
                  style="
                    width: 1px;
                    height: 80px;
                    background: gray;
                    margin: 20px auto auto 55%;
                  "
                ></div>
              </el-col>
              <el-col :span="4"
                ><div class="grid-content bg-purple-light">
                  <div class="block" style="width: 100%">
                    <el-image
                      src="/static/mp.png"
                      class="ercode"
                      style="
                        height: auto;
                        display: block;
                        border: 0;
                        margin: auto;
                        background: white;
                      "
                    ></el-image>
                  </div>
                  <div
                    style="text-align: center; font-size: 12px; margin-top: 4px"
                  >
                    扫码关注微信公众号
                  </div>
                </div></el-col
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="menu-mini" v-show="miniMenuShow">
      <div class="menu-mini-content">
        <div class="mask" @click="showMiniMenu"></div>
        <div
          style="border-bottom: 1px solid rgb(246, 246, 246); overflow: hidden"
        >
          <div
            class="logo-mini"
            style="
              padding-left: 10px;
              padding-top: 10px;
              padding-bottom: 10px;
              float: left;
            "
          >
            <img src="/static/logo.png" />
          </div>
          <div style="float: right">
            <i
              class="el-icon-close"
              style="font-size: 26px; margin-top: 12px; margin-right: 10px"
              @click="showMiniMenu"
            ></i>
          </div>
        </div>
        <el-menu v-if="miniShowType === 0" class="el-menu-vertical-demo">
          <el-menu-item>
            <el-input
              placeholder="请输入股票代码、名称、简拼"
              size="small"
              v-model="vm.searchKey"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
              ></el-button>
            </el-input>
          </el-menu-item>
        </el-menu>
        <el-menu
          v-if="miniShowType === 1"
          class="el-menu-vertical-demo"
          @select="handleSelect"
        >
          <el-menu-item index="user-favorite">收藏夹</el-menu-item>
          <!-- <el-menu-item index="user-exit">退出</el-menu-item> -->
        </el-menu>
        <el-menu
          v-if="miniShowType === 2"
          :router="true"
          class="el-menu-vertical-demo"
          :default-active="this.$route.path"
          @select="showMiniMenu"
        >
          <el-menu-item index="/jibenmian">基本面分析</el-menu-item>
          <el-menu-item index="/chicang">主力持仓</el-menu-item>
          <el-menu-item index="/yanbao">研究报告</el-menu-item>
          <el-menu-item index="/xinxipilu">信息披露</el-menu-item>
          <el-menu-item index="/shoufa">首发申报</el-menu-item>
          <el-menu-item index="/datalab">数据实验室</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div style="display: none">
      <img id="waterMarkImg" src="/static/waterMark-table.png" />
    </div>
    <login></login>

    <el-backtop target="#app"></el-backtop>
  </div>
</template>

<script>
import login from "./views/login";

export default {
  components: {
    login,
  },
  data() {
    return {
      miniMenuShow: false,
      miniShowType: 0,
      vm: {
        searchType: "1",
        searchKey: null,
        searchKeys: [],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    login() {
      // if (this.$core.isWeixin()) {
      //   this.wxLogin()
      // } else {
      //   this.$store.commit('loginFormVisible', true)
      // }
      this.wxLogin();
    },
    handleSelect(key, keyPath) {
      this.miniMenuShow = false;
      if (key === "user-center") {
      } else if (key === "user-favorite") {
        this.$router.push("/user-favorite");
      } else if (key === "user-exit") {
        this.$store.commit("logout");
      }
    },
    init() {
      // console.log(this.$route.path)
      if (!this.$store.state.user) {
        // this.$store.commit('login', {
        //   userid: '1',
        //   nickname: 'qq',
        //   sex: '1',
        //   headimgurl: ''
        // })
        this.$store.commit("token", localStorage.getItem("access_token"));

        if (!this.$store.state.token && this.$core.isWeixin()) {
          this.wxLogin();
          return;
        }

        if (this.$store.state.token) {
          this.$api.user.getUserInfo().then((r) => {
            this.$store.commit("login", r);
            this.$store.commit("init");
          });
        }
      }
    },
    wxLogin() {
      let uri = window.top.location.href;
      document.cookie = "redirect_uri=" + encodeURI(uri) + "; path=/";
      window.top.location.href = "/static/login/weixin.html";
    },
    showMiniSearch() {
      this.miniShowType = 0;
      if (this.miniMenuShow) this.miniMenuShow = false;
      else this.miniMenuShow = true;
    },
    showMiniUser() {
      if (!this.$store.state.user) {
        this.login();
      } else {
        this.miniShowType = 1;
        if (this.miniMenuShow) this.miniMenuShow = false;
        else this.miniMenuShow = true;
      }
    },
    showMiniMenu() {
      this.miniShowType = 2;
      if (this.miniMenuShow) this.miniMenuShow = false;
      else this.miniMenuShow = true;
    },
    search() {
      if (!this.vm.searchKey) return;
      var url = `/jibenmian?searchType=${this.vm.searchType}&searchKey=${
        this.vm.searchKey.split(" ")[0]
      }`;
      this.vm.searchKey = null;
      this.$router.push({ path: url });
    },
    searchKeys(queryString, cb) {
      if (!this.vm.searchKey) return;
      this.$api.shareInfoDetail
        .getSearchKeys(this.vm.searchKey.split(" ")[0])
        .then((r) => {
          this.vm.searchKeys = r;
          var rs = [];
          for (let i in r) {
            rs.push({ value: r[i] });
          }
          cb(rs);
        });
    },
  },
  name: "App",
};
</script>



// WEBPACK FOOTER //
// src/App.vue